/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
export default {
  decodePolyline(encoded) {
    const points = []
    let index = 0
    const len = encoded.length
    let lat = 0
    let lng = 0
    while (index < len) {
      let b
      let shift = 0
      let result = 0
      do {
        b = encoded.charAt(index++).charCodeAt(0) - 63
        result |= (b & 0x1f) << shift
        shift += 5
      } while (b >= 0x20)

      const dlat = ((result & 1) !== 0 ? ~(result >> 1) : (result >> 1))
      lat += dlat
      shift = 0
      result = 0
      do {
        b = encoded.charAt(index++).charCodeAt(0) - 63
        result |= (b & 0x1f) << shift
        shift += 5
      } while (b >= 0x20)
      const dlng = ((result & 1) !== 0 ? ~(result >> 1) : (result >> 1))
      lng += dlng

      points.push([lat / 1E5, lng / 1E5])
    }
    return points
  }
}
